import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/template/ATemplateStyle/index",{
        params: {
            page:params
        }
    } )
}

function SUBMIT_ADD(params) {
    return  axios.post("/template/ATemplateStyle/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/template/ATemplateStyle/edit",{ id:params } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/template/ATemplateStyle/editPost",{...params} )
}
function LIST_ORDER(params) {
    return  axios.post("/template/ATemplateStyle/listOrder",{list_orders:params} )
}

function DELE(params) {
    return  axios.get("/template/ATemplateStyle/delete",{
        params: {
            ids:params
        }
    } )
}
export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    LIST_ORDER,
    DELE
};